export class SlyShoppingWave {
  wave_id?: number;
  dateFrom?: Date;
  dateTo?: Date;
  date_from?: Date;
  date_to?: Date;

  constructor() {
    if (this.date_from && this.date_to) {
      this.dateFrom = this.date_from;
      this.dateTo = this.date_to;
    } else if (this.dateFrom && this.dateTo) {
      this.date_from = this.dateFrom;
      this.date_to = this.dateTo;
    }
  }
}
